<div class="absolute inset-0 flex min-w-0 flex-col overflow-hidden">
    <mat-drawer-container
        class="bg-card h-full flex-auto dark:bg-transparent"
        (backdropClick)="onBackdropClicked()"
    >
        <!-- Drawer -->
        <mat-drawer
            class="w-150 dark:bg-gray-900"
            [mode]="drawerMode"
            [opened]="drawerOpened"
            [position]="'end'"
            #matDrawer
        >
            <ng-container *ngIf="drawerOpened">
                <app-venue
                    [data]="selectedVenue"
                    (clicked)="close($event)"
                ></app-venue>
            </ng-container>

        </mat-drawer>

        <mat-drawer-content class="flex flex-col">
            <!-- Main -->
            <div class="flex flex-auto flex-col">
                <!-- Header -->
                <div class="bg-default flex flex-col items-start px-6 py-8 sm:flex-row sm:items-center sm:justify-between md:px-8">
                    <!-- Title -->
                    <div>
                        <div class="text-4xl font-extrabold leading-none tracking-tight">Venues</div>
                        <div class="text-secondary ml-0.5 font-medium">
                            <span>Manage all your Venues</span>
                        </div>
                    </div>
                    <!-- Actions -->
                    <div class="mt-4 sm:mt-0">
                        <button
                            class="ml-3"
                            mat-flat-button
                            [color]="'primary'"
                            (click)="editVenue(null)"
                        >
                            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                            <span class="ml-2 mr-1">Add Venue</span>
                        </button>
                    </div>

                </div>
                <table
                    class="bg-card w-full text-left border-separate border-spacing-0 mat-elevation-z0 !bg-white"
                    mat-table
                    matSort
                    matSortActive="name"
                    matSortDirection="asc"
                    (matSortChange)="onSortChange($event)"
                    [dataSource]="recentVenuesDataSource"
                    [trackBy]="trackByFn"
                    #recentVenuesTable
                >
                    <!-- Venue -->
                    <ng-container matColumnDef="name">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="name"
                            class="!bg-gray-50 px-6 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600"
                        >
                            Venue
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4 whitespace-nowrap"
                        >
                            <div
                                class="flex items-center gap-3"
                                (click)="viewVenue(transaction)"
                                style="cursor: pointer;"
                            >
                                <img
                                    src="assets/icons/location.png"
                                    alt="icon"
                                    class="h-8 w-8"
                                >
                                <span class="font-medium text-gray-900">{{ transaction.name }}</span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Location -->
                    <ng-container matColumnDef="location">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="location.placeName"
                            class="!bg-gray-50 px-6 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600"
                        >
                            Location
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4"
                        >
                            <span class="truncate text-gray-500 max-w-xs block">{{ transaction.location.placeName }}</span>
                        </td>
                    </ng-container>

                    <!-- Status -->
                    <ng-container matColumnDef="status">
                        <th
                            mat-header-cell
                            *matHeaderCellDef mat-sort-header="status"
                            class="!bg-gray-50 px-6 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600"
                        >
                            Status
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4"
                        >
                            <span
                                class="inline-flex items-center rounded-full px-3 py-1 font-medium"
                                [ngClass]="{
                                    'bg-red-200 text-red-800 dark:bg-red-600 dark:text-red-50':
                                        transaction.status === 'inactive',
                                    'bg-green-200 text-green-800 dark:bg-green-600 dark:text-green-50':
                                        transaction.status === 'active',
                                }"
                            >
                                {{ transaction.status==='active' ? 'Active' : 'In-active' }}
                            </span>

                        </td>
                    </ng-container>

                    <!-- Status -->
                    <ng-container matColumnDef="actions">
                        <th
                            mat-header-cell
                            *matHeaderCellDef
                            class="!bg-gray-50 px-6 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600"
                        >
                            Actions
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let transaction"
                            class="px-6 py-4"
                        >
                            <button
                                mat-icon-button
                                (click)="editVenue(transaction)"
                                matTooltip="Edit Venue"
                            >
                                <mat-icon [svgIcon]="'heroicons_outline:pencil'"></mat-icon>
                            </button>
                            <button
                                mat-icon-button
                                color="warn"
                                (click)="delete(transaction.id)"
                                matTooltip="Delete Venue"
                            >
                                <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <!-- Footer -->
                    <ng-container matColumnDef="recentOrdersTableFooter">
                        <td
                            class="border-0 px-0 py-6"
                            mat-footer-cell
                            *matFooterCellDef
                            colspan="6"
                        ></td>
                    </ng-container>

                    <!-- Header row -->
                    <tbody>
                        <tr
                            mat-header-row
                            *matHeaderRowDef="recentVenuesTableColumns"
                            class="border-b border-gray-200"
                        ></tr>

                        <!-- Data rows -->
                        <tr
                            class="h-16 border-b border-gray-200 hover:!bg-gray-50 transition-colors"
                            mat-row
                            *matRowDef="let row; columns: recentVenuesTableColumns"
                        ></tr>

                        <!-- Footer row -->
                        <tr
                            class="h-16 border-0"
                            mat-footer-row
                            *matFooterRowDef="['recentOrdersTableFooter']"
                        ></tr>
                    </tbody>
                </table>
                <mat-paginator
                    [length]="totalItems"
                    [pageIndex]="pageIndex"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="[5, 10, 25, 50]"
                    [showFirstLastButtons]="true"
                    (page)="onPageChange($event)"
                ></mat-paginator>

            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>
